import React from 'react';
import AdminHeader from './AdminHeader.js';
import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_BANK_DETAILS } from '../graphql/Query/SellerPruff.js';
import SpinLoader from '../components/SpinLoader.js';
import { GET_PAYMENT_TRANSACTION } from '../graphql/Query/SellerTransaction.js';
import CustomPagination from '../components/Pagination.js';
import NoDataFound from '../components/NoDataFound.js';
import moment from 'moment';

const AdminPrufSingle = () => {
  const location = useLocation();
  const [pagePayment, setPagePayment] = useState(0);
  const [limitPayment] = useState(15);
  const { data, loading } = useQuery(GET_CUSTOMER_BANK_DETAILS, {
    variables: {
      customerId: location?.state?.customerId
    },
    fetchPolicy: "cache-and-network"
  })
  const bankDetails = data?.getBankDetails?.data?.[0];
  const { data: GetOrderOrderData, loadingData } = useQuery(GET_PAYMENT_TRANSACTION, {
    variables: {
      page: pagePayment + 1,
      limit: limitPayment,
      "sort": {
        "key": "createdAt",
        "type": -1
      },
      customerId: location?.state?.customerId
    },
    fetchPolicy: "cache-and-network"
  })
  const handlePageClickPayment = (selectedPage) => {
    setPagePayment(selectedPage);
    // refetch(); // Refetch data with the new page
  };
  return (
    <div>
      <AdminHeader />
      <div className="w-1/2">
        <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
              <thead className="bg-slate-100 text-gray-700">
                <tr>
                  <th className="px-4 py-3">No.</th>
                  <th className="px-4 py-3">Date & Time</th>
                  <th className="px-4 py-3">Receive Payment</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Reference</th>
                </tr>
              </thead>
              <tbody>
                {loadingData ? (
                  <tr>
                    <td colSpan="4" className="text-center py-20">
                      <SpinLoader className="text-primary" />
                    </td>
                  </tr>
                ) : GetOrderOrderData?.getPaymentTransactionDataForAdmin?.count > 0 ? (
                  GetOrderOrderData?.getPaymentTransactionDataForAdmin?.data.map((shipment, index) => (
                    <tr key={index} className="border-t bg-white">
                      <td className="px-4 py-1 text-gray-700">{pagePayment * limitPayment + index + 1}</td>
                      <td className="px-4 py-1 text-gray-700">
                        {moment(shipment?.createdAt).format('DD/MM/YYYY HH:mm')}
                      </td>
                      <td className="px-4 py-1 text-gray-700 font-semibold">
                        ₹{shipment?.paymentAmount || "0"}
                      </td>
                      <td className="px-4 py-4">
                        <span
                          className={`bg-${shipment?.cod_payment_status === "success"
                            ? "green"
                            : shipment?.cod_payment_status === "pending" ? 'indigo' : "gray"
                            }-600 px-3 py-1 rounded-lg text-sm font-semibold`}
                        >
                          {shipment?.cod_payment_status || "Unknown"}
                        </span>
                      </td>
                      <td>Total {shipment?.totalShipment} Shipments</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-20">
                      <NoDataFound />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <CustomPagination
          totalItems={GetOrderOrderData?.getPaymentTransactionDataForAdmin?.count || 0} // Total number of items
          limit={limitPayment}
          pageNo={pagePayment} // Current page number (zero-based index)
          handlePageClick={handlePageClickPayment} // Handler to change page
        />
      </div>
      <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-md mt-2">
        <h2 className="text-center text-2xl font-bold mb-4">{location?.state?.email}</h2>

        {loading ? (
          <p className="text-center text-lg"> <SpinLoader /> </p>
        ) : (
          <div className="grid grid-cols-3 gap-4 mt-3">
            {/* Bank Holder Name */}
            <div>
              <label className="block text-gray-600 font-medium">Bank Holder Name</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.bankHolderName || ""}
                readOnly
              />
            </div>

            {/* IFSC Code */}
            <div>
              <label className="block text-gray-600 font-medium">IFSC Code</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.ifscCode || ""}
                readOnly
              />
            </div>

            {/* Account Number */}
            <div>
              <label className="block text-gray-600 font-medium">Account Number</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.accountNumber || ""}
                readOnly
              />
            </div>

            {/* Bank Name */}
            <div>
              <label className="block text-gray-600 font-medium">Bank Name</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.bankName || ""}
                readOnly
              />
            </div>

            {/* Branch Name */}
            <div>
              <label className="block text-gray-600 font-medium">Branch Name</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.branch || ""}
                readOnly
              />
            </div>

            {/* GST Number */}
            <div>
              <label className="block text-gray-600 font-medium">GST Number</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.gstNumber || ""}
                readOnly
              />
            </div>

            {/* Account Type */}
            <div>
              <label className="block text-gray-600 font-medium">Account Type</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.accountType || ""}
                readOnly
              />
            </div>

            {/* State */}
            <div>
              <label className="block text-gray-600 font-medium">State</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.state || ""}
                readOnly
              />
            </div>

            {/* City */}
            <div>
              <label className="block text-gray-600 font-medium">City</label>
              <input
                type="text"
                className="border p-2 rounded w-full"
                value={bankDetails?.city || ""}
                readOnly
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPrufSingle;
